//@ts-strict-ignore
import { ResponsivePie } from '@nivo/pie';
import React from 'react';
import { OrdinalColorScaleConfig } from '@nivo/colors';
import { PieSvgProps } from '@nivo/pie/dist/types/types';

type ISalesAnalyticsPieProps = {
  data: Array<any>;
  height: number;
  graphOnly: boolean;
  colorScheme?: OrdinalColorScaleConfig;
};

export const SalesAnalyticsPie = ({
  data,
  height,
  colorScheme: colors = { scheme: 'nivo' },
  graphOnly,
}: ISalesAnalyticsPieProps) => {
  let data2: Array<any> = [];
  data = data.map((entry) => {
    const entryValue = entry.description || entry.reference || '---';
    data2.push({
      id: entryValue,
      label: entryValue,
      value: entry.right_comparison_value || 0,
    });
    return {
      id: entryValue,
      label: entryValue,
      value: entry.left_comparison_value || 0,
    };
  });

  const piePropsExceptData: Omit<PieSvgProps<any>, 'height' | 'width' | 'data'> = {
    margin: { top: 40, right: 80, bottom: graphOnly ? 40 : 80, left: 80 },
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 3,
    colors: colors,
    borderWidth: 1,
    arcLabelsSkipAngle: 10,
    arcLabelsRadiusOffset: 6,
    animate: true,
    motionConfig: 'gentle',
    defs: [
      {
        id: 'dots',
        type: 'patternDots',
        background: 'inherit',
        color: 'rgba(255, 255, 255, 0.3)',
        size: 4,
        padding: 1,
        stagger: true,
      },
      {
        id: 'lines',
        type: 'patternLines',
        background: 'inherit',
        color: 'rgba(255, 255, 255, 0.3)',
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
    ],
    legends: graphOnly
      ? []
      : [
          {
            anchor: 'bottom',
            direction: 'row',
            translateY: 56,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#000',
                },
              },
            ],
          },
        ],
  };

  return (
    <>
      <div style={{ height: height, width: '50%' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Previous Year</div>
        <ResponsivePie data={data} {...piePropsExceptData} />
      </div>
      <div style={{ height: height, width: '50%' }}>
        <div style={{ width: '100%', textAlign: 'center' }}>This Year</div>
        <ResponsivePie data={data2} {...piePropsExceptData} />
      </div>
    </>
  );
};
